import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import { axiosInstance } from "@helpers/axios-instance";

export function RoleLookupDS() {
  return new DataSource({
    store: new CustomStore({
      key: "id",
      load: async (loadOptions) => {
        return axiosInstance({
          method: "POST",
          url:  `SystemUser/GetRoleLookup`,
          data: loadOptions,
        })
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            console.error(err);
          });
      },
      byKey: async (key) => {
        return axiosInstance({
          method: "GET",
          url:  `SystemUser/GetRole?id=${key}`,
        })
          .then((response) => {
            return response.data.data;
          })
          .catch((err) => {
            console.error(err);
          });
      },
    }),
  });
}
